import { GlModal } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf } from '@gitlab/ui/src/utils/i18n';
import { renderLeaveSuccessToast } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/groups_list/utils.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__, __ } from '~/locale';
import { deleteGroupMember } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/api/groups_api.js?vue3';
export default {
    name: 'GroupListItemLeaveModal',
    components: {
        GlModal
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: false,
            default: false
        },
        modalId: {
            type: String,
            required: true
        },
        group: {
            type: Object,
            required: true
        }
    },
    emits: [
        'change',
        'success'
    ],
    data () {
        return {
            isLoading: false
        };
    },
    modal: {
        actionCancel: {
            text: __('Cancel')
        }
    },
    computed: {
        title () {
            return sprintf(s__('GroupsTree|Are you sure you want to leave "%{fullName}"?'), {
                fullName: this.group.fullName
            });
        },
        actionPrimary () {
            return {
                text: s__('GroupsTree|Leave group'),
                attributes: {
                    variant: 'danger',
                    loading: this.isLoading
                }
            };
        }
    },
    methods: {
        async handlePrimary () {
            this.isLoading = true;
            try {
                await deleteGroupMember(this.group.id, gon.current_user_id);
                this.$emit('success');
                renderLeaveSuccessToast(this.group);
            } catch (error) {
                createAlert({
                    message: s__('GroupsTree|An error occurred while leaving the group. Please refresh the page to try again.'),
                    error,
                    captureError: true
                });
            } finally{
                this.isLoading = false;
            }
        }
    }
};
